/**
 * Cloud Attack Path Queries
 *
 * Pre-built queries for cloud infrastructure privilege escalation paths.
 * Currently focuses on AWS IAM attack primitives.
 *
 * To add new cloud query: Add query object to CLOUD_ATTACK_PATH_QUERIES array.
 * Query will automatically appear in defaultQueries.ts export.
 */

import type { SavedQuery } from '@/sections/insights/queryBuilder/types/SavedQuery';

import { QueryFolders } from './folders';

export const CLOUD_ATTACK_PATH_QUERIES: SavedQuery[] = [
  {
    id: 'aws-sts-assume-role',
    name: 'AWS STS AssumeRole + PutRolePolicy Privilege Escalations',
    type: 'graph',
    description:
      'Find AWS resources that can assume roles on other AWS resources via sts:AssumeRole permissions.',
    folderId: QueryFolders.CLOUD_ATTACK_PATHS,
    query: {
      node: {
        labels: ['AWSResource'],
        filters: [
          {
            field: 'resourceType',
            operator: '=',
            value: 'AWS::Service',
            not: true,
          },
        ],
        relationships: [
          {
            label: 'IAM_AWS_PERMISSION',
            filters: [
              {
                field: 'actions',
                operator: 'ANY_STARTS_WITH',
                value: 'sts:AssumeRole',
              },
              {
                field: 'actions',
                operator: 'ANY_STARTS_WITH',
                value: 'iam:PutRolePolicy',
              },
            ],
            target: {
              labels: ['AWSResource'],
              filters: [
                {
                  field: 'resourceType',
                  operator: '=',
                  value: 'AWS::IAM::Role',
                },
              ],
            },
          },
        ],
      },
    },
  },
];
